<template>
  <section>
    <el-input
      v-if="hasDay"
      ref="input1"
      v-model="day"
      type="number"
      placeholder="DD"
      :disabled="disabled"
      size="small"
      @blur="handleBlur"
      @focus="handleFocus(1)"
      @keyup.native="handleKeyUp"
      @keydown.native="handleKeyDown($event, 'day')"
      @input="handleInput($event, 'day', 2)"></el-input>
    <el-input
      ref="input2"
      v-model="month"
      type="number"
      placeholder="MM"
      :disabled="disabled"
      size="small"
      @blur="handleBlur"
      @focus="handleFocus(2)"
      @keyup.native="handleKeyUp"
      @keydown.native="handleKeyDown($event, 'month')"
      @input="handleInput($event, 'month', 2)"></el-input>
    <el-input
      ref="input3"
      v-model="year"
      type="number"
      class="year"
      :class="{'none-day-year':!hasDay}"
      placeholder="YYYY"
      :disabled="disabled"
      size="small"
      @blur="handleBlur"
      @focus="handleFocus(3)"
      @keyup.native="handleKeyUp"
      @keydown.native="handleKeyDown($event, 'year')"
      @input="handleInput($event, 'year', 4)"></el-input>
  </section>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'VBirthDay',
  model:{
    prop: 'date',
    event: 'input'
  },
  props:{
    date:{
      type: String,
      default: ''
    },
    disabled:{
      type: Boolean,
      default: false
    },
    hasDay:{
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      year: '',
      month: '',
      day: '',
      focusIndex: 1,
      iskeydown: false
    }
  },
  watch:{
    date:{
      immediate: true,
      handler(val){
        if(val){
          // 先把日期后面的时间给去掉
          let res = val.split(' ')

          // 接着再转换年月日
          let date = res[0].split('-')
          this.year = date[0]
          this.month = date[1]
          if(this.hasDay)
            this.day = date[2]
        }
      }
    },
    hasDay:{
      immediate: true,
      handler(val){
        if(!val){
          this.focusIndex = 2
        }else {
          this.focusIndex = 1
        }
      }
    },
    day:{
      immediate: true,
      handler(val){
        if(val > 31){
          this.day = 31
        }
      }
    },
    month:{
      immediate: true,
      handler(val){
        if(val > 12){
          this.month = 12
        }
      }
    },
    year:{
      immediate: true,
      handler(val){
        let now_date = new Date()
        let now_year = now_date.getFullYear()
        if(val > now_year){
          this.year = now_year
        }
      }
    }
  },
  methods: {
    handleKeyUp(){
      this.iskeydown = false
    },

    handleKeyDown(e, key){
      this.iskeydown = true
      if(e.keyCode == 8){
        // 按退格键如果当前输入框为空则跳到上一个输入框并且如果上一个框有值删除最后一个字符
        let hasDayIndex = this.hasDay?1:2
        let preFocusIndex = this.focusIndex > hasDayIndex? this.focusIndex - 1 : hasDayIndex
        let val = this[key]
        if(val.length === 0){
          e.preventDefault()
          let preVal = this.$refs[`input${preFocusIndex}`].value
          this.focusIndex = preFocusIndex < 1? 1 : preFocusIndex
          this.$refs[`input${this.focusIndex}`].focus()
          if(preVal){
            let preKey = key == 'year'? 'month' : key == 'month'? 'day' : ''
            // 退格的上一个框都是2个字符，就不再加判断了，直接写死2
            let preLen = 2
            if(preKey){
              this[preKey] = preVal.slice(0, preLen-1)
            }
          }
        }
      }
    },

    handleInput(val, key, len){
      if(this.iskeydown){
        if(this[key].length > len-1){
          // 如果输入的内容长度超过限定的长度则跳到下一个输入框并将最后那个输入的数字赋值到下一个输入框
          let res = val.toString()
          let nextFocusIndex = this.focusIndex + 1
          this[key] = res.slice(0, len)
          let newNextVal = res.slice(len)
          this.focusIndex = nextFocusIndex >= 3? 3 : nextFocusIndex
          let nextVal = this.$refs[`input${this.focusIndex}`].value
          this.$refs[`input${this.focusIndex}`].focus()

          // 如果下一个输入框是为空则直接赋值最后一个输入的数字
          if(!nextVal){
            let nextKey = key == 'day'? 'month' : key == 'month'? 'year' : ''
            if(nextKey){
              this[nextKey] = newNextVal
            }
          }
        }
      }

      let day = `${this.year}-${this.month}-${this.day}`
      let petBith = `${this.year}-${this.month}`
      if(this.hasDay){
        if(this.year && this.month && this.day){
          this.$emit('input', day)
        }else{
          this.$emit('input', '')
        }
      }else {
        if(this.year && this.month){
          this.$emit('input', petBith)
        }else{
          this.$emit('input', '')
        }
      }

    },

    handleFocus(index){
      this.focusIndex = index
    },

    handleBlur(){
      if(this.day && this.month && this.year){
        // 如果超出当前月份最大天数则用当前最大天数
        let daysInMonth = dayjs(`${this.year}-${this.month}`).daysInMonth()
        this.day = this.day > daysInMonth? daysInMonth : this.day

        // 如果日期超过当前最大日期则用当前最大日期
        let date_temp = `${this.year}-${this.month}-${this.day}`
        let inputUnix = dayjs(date_temp).unix()
        let nowUnix = dayjs().unix()
        if(inputUnix > nowUnix){
          this.day = dayjs().day()
          this.month = dayjs().month() + 1
        }
      }

      if(this.day){
        this.day = this.day.toString().padStart(2,'0')
        if(this.day < 1){
          this.day = 1
        }
      }

      if(this.month){
        this.month = this.month.toString().padStart(2,'0')
        if(this.month < 1){
          this.month = 1
        }
      }
      this.$emit('change')
    },
  },
}
</script>
<style lang='scss' scoped>
.el-input{
  display: inline-block;
  width: 80px;
  margin-right: 15px;
}
.year{
  width: 100px;
  &.none-day-year{
    width: calc(100% - 95px);
    margin-right: 0;
  }
}
</style>
